import React from "react";
import { Box, Typography } from "@mui/material";
import CircularLoader from "./CircularLoader";
import { BASE, GREY } from "../../utils/constants/colors";
import { fontWeight } from "../../utils/constants/UI";

const DashboardLoader = ({ message = "Loading dashboard data..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        minHeight: "400px",
        borderRadius: "16px",
        zIndex: 10,
        gap: "16px",
      }}
    >
      <CircularLoader size={60} />
      {message && (
        <Typography
          sx={{
            color: GREY.PRIMARY,
            fontWeight: fontWeight.MEDIUM,
            fontSize: "14px",
            letterSpacing: "0.5px",
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default DashboardLoader;
